import './App.css';
import Navigation from './component/Navigation/navigation.component'
import Discovery from './component/Discovery/discovery.component'
function App() {
  return (
    <div className="App">
      <Navigation/>
     <Discovery/>
    </div>
  );
}

export default App;
